var _excluded = ["children", "rtl", "className"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './SystemMessageBanner.css';
import React from 'react';
import { get } from '../../../utils';
import { Link, Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import { commonStyles, rtlStyles, ltrStyles } from '../BannerLarge';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var SystemMessageBanner = function SystemMessageBanner(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.warn('BannerLarge component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BannerLarge component is empty: please provide data source]");
    }
    return null;
  }
  var buttonClickAnalytics = get(fields, 'data.buttonClickAnalytics');
  var item = get(fields, 'data.item') || {};
  var title = get(fields, 'data.item.title.jss.value');
  var hasTitle = Boolean(get(item, 'title.jss.value'));
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var ctaLabel = get(item, 'ctaLabel.jss.value', '');
  var ctaAnalytics = get(item, 'ctaAnalytics.jss.value', '');
  var ctaLinkHref = get(item, 'ctaLink.jss.value.href', '');
  var ctaLinkTitle = get(item, 'ctaLink.jss.value.title', '');
  // const ctaLinkType: string = get(fields, 'ctaLink.value.linktype', '');
  var colourTheme = get(params, 'Color', get(item, 'colourTheme.jss.fields.themeName.value', 'theme-1'));
  var renderLink = function renderLink() {
    if (pageEditing) return /*#__PURE__*/React.createElement("button", {
      "data-testid": "banner-large-editing-cta-link",
      className: "btn btn-secondary-dark"
    }, /*#__PURE__*/React.createElement(Link, {
      field: item.ctaLink
    }));
    if (!ctaLabel || !ctaLinkHref) return null;
    return /*#__PURE__*/React.createElement("a", {
      className: "btn btn-secondary-dark",
      href: ctaLinkHref,
      title: title,
      "aria-label": title,
      "aria-labelledby": title,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(buttonClickAnalytics, params), ctaAnalytics);
      }
    }, ctaLabel);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    removePaddingMobile: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "row banner banner--error  banner--large banner-system",
    "data-cy": "banner-large"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-lg-8 col-xl-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__card ".concat(colourTheme, " theme-contrast")
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__text"
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "banner__header",
    "data-cy": "banner-large-title"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "h1",
    tag: "h1",
    field: get(item, 'title.jss')
  })), hasDescription && /*#__PURE__*/React.createElement("div", {
    className: "banner__body",
    "data-cy": "banner-large-description"
  }, /*#__PURE__*/React.createElement(RichText, {
    className: "body-large",
    tag: "p",
    field: get(item, 'description.jss')
  })), /*#__PURE__*/React.createElement("div", {
    className: "banner__footer",
    "data-cy": "banner-large-cta"
  }, renderLink())))), /*#__PURE__*/React.createElement("div", {
    className: "col-md"
  })));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    className: "".concat(commonStyles, " ").concat(systemStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, otherProps), children);
};
var systemStyles = "snig8s4";
export default SystemMessageBanner;